module.exports = __webpack_public_path__ + "img/delAccModalEN.fb56fb3c.png";